import { Action, createReducer, on } from '@ngrx/store';
import {
  ClearLabelsDataAction,
  GetLabelsSuccess,
  GetOndemandLangLabelsSuccess,
} from './labels.actions';
import { SdfCardEnglishLabels, SdfCardFrechLabels } from './labels.mock';
import { Labels } from 'src/app/app.models';

export interface LabelsState {
  labels?: LabelDict;
}

export interface LabelDict {
  [key: string]: LabelDict;
}

const initialState: LabelsState = {
  labels: {},
};

export function LabelsReducer(state: LabelsState | undefined, action: Action) {
  return reducer(state, action);
}

function getSdfCardLabels(mainData: any): any {
  mainData = { ...mainData, sdfCardLabels: SdfCardEnglishLabels };
  return mainData;
}

// ToDo will remove after actual translations implementation
function getOndemandLabels(mainData: any): any {
  const data = mainData.state;
  if (mainData && mainData.lang && mainData.lang !== 'en') {
    mainData = { ...data, sdfCardLabels: SdfCardFrechLabels };
  } else {
    mainData = { ...data, sdfCardLabels: SdfCardEnglishLabels };
  }
  return mainData;
}

export const reducer = createReducer(
  initialState,
  on(
    GetLabelsSuccess,
    (state, { getLabelsResponse }) =>
      ({
        ...state,
        labels: { ...getLabelsResponse.state },
        // labels: getSdfCardLabels(getLabelsResponse.state),
      } as LabelsState)
  ),
  on(
    GetOndemandLangLabelsSuccess,
    (state, { getLabelsResponse }) =>
      ({
        ...state,
        labels: { ...getLabelsResponse.state },
        // labels: getOndemandLabels(getLabelsResponse),
      } as LabelsState)
  ),
  on(ClearLabelsDataAction, (state) => initialState)
);
